export default __webpack_public_path__ + "static/media/Blade's Bracers of the Firebringer.aa9d01af.jpg";